class ProductVariationOption extends window.BAO.CustomElement() {
  static get requiredAttributes () {
    return ['data-option-name', 'data-option-value-handleized']
  }

  connectedCallback () {
    super.connectedCallback()
  
    requestAnimationFrame(() => {
      const variationEl = this.closest('product-variation')
      if (!variationEl) return
  
      const current = variationEl.dataset.currentOptionValueHandleized?.trim()
      const mine = this.dataset.optionValueHandleized?.trim()
  
      if (current && mine && current === mine) {
        this.setAttribute('active', '')
      } else {
        this.removeAttribute('active')
      }
  
      const bulb = variationEl.dataset.bulb?.trim()
      const cable = variationEl.dataset.cable?.trim()
      const length = variationEl.dataset.length?.trim()
      const swatchValue = this.dataset.optionValueHandleized?.trim()
      const optionName = this.dataset.optionName
  
      const combination = {
        bulb: optionName === 'bulb_colour' ? swatchValue : bulb,
        cable: optionName === 'cable_colour' ? swatchValue : cable,
        length: length
      }
  
      if (!window.ProductVariationData?.length) return
  
      const match = window.ProductVariationData.find(p =>
        p.bulb?.toLowerCase() === combination.bulb?.toLowerCase() &&
        p.cable?.toLowerCase() === combination.cable?.toLowerCase() &&
        p.length?.toLowerCase() === combination.length?.toLowerCase()
      )
  
      this.toggleAttribute('disabled', !match)
  
      // If this option has an anchor, inject a valid URL
      const anchor = this.querySelector('a')
      if (match?.url && anchor) {
        anchor.setAttribute('href', match.url)
      }
    })
  }

  get productVariationEl () {
    return this.closest('product-variation')
  }
}

if (!customElements.get('product-variation-option')) {
  customElements.define('product-variation-option', ProductVariationOption)
}

class ProductVariations extends window.BAO.CustomElement() {
  static get requiredAttributes () {
    return ['data-product-handle', 'data-collection-handle']
  }

  connectedCallback () {
    super.connectedCallback()
    this.loadVariantDataFromDOM()
  }

  loadVariantDataFromDOM () {
    const variantEls = document.querySelectorAll('.js-product-meta')
    window.ProductVariationData = Array.from(variantEls).map(el => ({
      handle: el.dataset.productHandle,
      bulb: el.dataset.bulb,
      cable: el.dataset.cable,
      length: el.dataset.length
    }))
  }
}

if (!customElements.get('product-variations')) {
  customElements.define('product-variations', ProductVariations)
}

class ProductVariation extends window.BAO.CustomElement() {
  static get requiredAttributes () {
    return [
      'data-filter-by',
      'data-current-option-name',
      'data-current-option-value',
      'data-current-option-value-handleized',
    ]
  }

  static get requiredElements () {
    return ['options']
  }

  connectedCallback () {
    super.connectedCallback()
  
    if (!this.els?.options?.element) return

    if (this.dataset.currentOptionName === 'bulb_colour') {
      this.dataset.bulb = this.dataset.currentOptionValueHandleized
    }
    if (this.dataset.currentOptionName === 'cable_colour') {
      this.dataset.cable = this.dataset.currentOptionValueHandleized
    }
    if (
      this.dataset.currentOptionName === 'length_of_lights_m' ||
      this.dataset.currentOptionName === 'width'
    ) {
      this.dataset.length = this.dataset.currentOptionValueHandleized
    }
  
    this.render()
  }


  async render () {
    const html = await this.variationOptionHTML()

    if (!html.length) {
      this.remove()
      return
    }

    this.els.options.element.innerHTML = html

    const swatchEls = this.els.options.element.querySelectorAll('product-variation-option')

    swatchEls.forEach((el) => {
      el.dataset.parentBulb = this.dataset.bulb
      el.dataset.parentCable = this.dataset.cable
      el.dataset.parentLength = this.dataset.length
    
      if (!(el instanceof ProductVariationOption)) {
        customElements.upgrade(el)
      }
    
      if (typeof el.connectedCallback === 'function') {
        el.connectedCallback()
      }
    })


    if (
      this.dataset.currentOptionName === 'length_of_lights_m' ||
      this.dataset.currentOptionName === 'width'
    ) {
      requestAnimationFrame(() => {
        const valueEl = this.els.options.element.querySelector('[data-product-variation-select-el="value"]')
        const currentValue = this.dataset.currentOptionValue
        if (valueEl && currentValue) {
          valueEl.textContent = currentValue
        }
      })
    }
  }

  async variationOptionHTML () {
    const { currentOptionName, filterBy } = this.dataset

    const html = await window.BAO.sectionRenderer.fetchSingle(
      `product-variation-options-${currentOptionName}`,
      `/collections/${this.productVariationsEl.dataset.collectionHandle}?${filterBy}`,
    )

    window.sessionStorage.setItem(this.storageKey, html)

    return window.BAO.sectionRenderer.getInnerHtml(html)
  }

  get productVariationsEl () {
    return this.closest('product-variations')
  }

  get storageKey () {
    return `${this.productVariationsEl.dataset?.productHandle}-${this.dataset.currentOptionName}`
  }
}

if (!customElements.get('product-variation')) {
  customElements.define('product-variation', ProductVariation)
}

